var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoteEmpty2 = function SvgNoteEmpty2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.32 20.881-1.96 8.36c-1.68 7.22-5 10.14-11.24 9.54-1-.08-2.08-.26-3.24-.54l-3.36-.8c-8.34-1.98-10.92-6.1-8.96-14.46l1.96-8.38c.4-1.7.88-3.18 1.48-4.4 2.34-4.84 6.32-6.14 13-4.56l3.34.78c8.38 1.96 10.94 6.1 8.98 14.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.12 38.78c-1.24.84-2.8 1.54-4.7 2.16l-3.16 1.04c-7.94 2.56-12.12.42-14.7-7.52L5 26.56c-2.56-7.94-.44-12.14 7.5-14.7l3.16-1.04c.82-.26 1.6-.48 2.34-.62-.6 1.22-1.08 2.7-1.48 4.4l-1.96 8.38c-1.96 8.36.62 12.48 8.96 14.46l3.36.8c1.16.28 2.24.46 3.24.54ZM25.28 17.059l9.7 2.46M23.32 24.8l5.8 1.48",
    opacity: 0.4
  }))));
};
export default SvgNoteEmpty2;